// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as RequirementVMMapper$PorterinFeature from "../view-model/RequirementVMMapper.mjs";
import * as FareEstimateReqDropdownModuleScss from "../styles/FareEstimateReqDropdown.module.scss";

var styles = FareEstimateReqDropdownModuleScss;

function FareEstimateReqDropdownCmp(Props) {
  var requirement_placeholder = Props.requirement_placeholder;
  var disabled = Props.disabled;
  var value = Props.value;
  var requirementHandler = Props.requirementHandler;
  var requirement_labels = Props.requirement_labels;
  var icon = Props.icon;
  var match = React.useState(function () {
        return false;
      });
  var setIsDropdownOpen = match[1];
  return React.createElement("div", {
              className: styles["requirement-dropdown-container"]
            }, React.createElement("input", {
                  className: styles["requirement-input"],
                  disabled: disabled,
                  placeholder: requirement_placeholder,
                  readOnly: true,
                  type: "text",
                  value: value,
                  onClick: (function (param) {
                      Curry._1(setIsDropdownOpen, (function (isOpen) {
                              return !isOpen;
                            }));
                    })
                }), React.createElement("div", {
                  className: styles["requirement-dropdown-arrow-icon"],
                  onClick: (function (param) {
                      Curry._1(setIsDropdownOpen, (function (isOpen) {
                              return !isOpen;
                            }));
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: icon.path,
                      height: 8.0,
                      width: 10.0,
                      quality: 100.0,
                      alt: icon.alt_text
                    })), React.createElement("div", {
                  className: "" + styles["requirement-dropdown"] + " " + (
                    match[0] ? styles.open : styles.close
                  ) + ""
                }, React.createElement("div", {
                      className: styles["requirement-dropdown-list"]
                    }, Belt_List.toArray(Belt_List.mapWithIndex(RequirementVMMapper$PorterinFeature.getRequirementList(undefined), (function (index, requirement) {
                                return React.createElement("div", {
                                            key: String(index),
                                            className: styles["requirement-dropdown-list-item"],
                                            onClick: (function (param) {
                                                Curry._1(requirementHandler, requirement);
                                                Curry._1(setIsDropdownOpen, (function (isOpen) {
                                                        return !isOpen;
                                                      }));
                                              })
                                          }, RequirementVMMapper$PorterinFeature.getRequirementLabel(requirement, requirement_labels));
                              }))))));
}

var make = FareEstimateReqDropdownCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
